module.exports = __webpack_public_path__ + "img/aj-ajold.e8ae4f41.jpg";